import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import numeral from "numeral";

export default class Appointment_card extends Component {
  render() {
    const { is_group_session, total_participants, max_capacity, bookings } = this.props;
    const capacityPercentage = is_group_session && max_capacity > 0
      ? (total_participants / max_capacity) * 100
      : 0;

    // Pass all group session data via route state (using API field names directly)
    const groupState = is_group_session ? {
      bookings: bookings || [],
      total_participants,
      max_capacity,
      total_amount_paid: this.props.total_amount_paid,
      total_rizevo_commission: this.props.total_rizevo_commission,
      total_discount_amount: this.props.total_discount_amount,
      total_priority_booking: this.props.total_priority_booking,
      total_balance_amount: this.props.total_balance_amount,
      upfront_percentage_payment: this.props.upfront_percentage_payment,
      handles_processing_fee: this.props.handles_processing_fee,
      service_name: this.props.service_name,
    } : undefined;

    return (
      <NavLink to={{
        pathname: `/bookings/${this.props.identifier}/booking`,
        state: groupState
      }}>
        <div className={`appointment card ${is_group_session ? 'group-session-card' : ''}`}>
          <div className={`header ${is_group_session ? 'group-session' : 'individual-session'} flex space-btw`}>
            <div className="text">
              <p className="name">
                {is_group_session ? this.props.service_name : `${this.props.customer?.first_name} ${this.props.customer?.last_name}`}
              </p>
              <p className="description_ellipsis">
                {this.props.start_time} - {this.props.end_time}
              </p>
             
              {is_group_session && (
                <div>
                  <span className="capacity-text">{total_participants} of {max_capacity}</span>
                  <div className="capacity-progress-container">
                    <div className="capacity-progress-bar">
                      <div
                        className="capacity-progress-fill"
                        style={{ width: `${capacityPercentage}%` }}
                      ></div>
                    </div>
                
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="footer flex space-btw">
            <p className="time">₦{numeral(is_group_session ? this.props.total_amount_paid : this.props.total_cost).format("0,0.00")}</p>
            {is_group_session ? (
              <span className="group-badge">GROUP</span>
            ) : (
              <p className="state" data-state={this.props.status === 'reserved' ? 'booked' : this.props.status}></p>
            )}
          </div>
        </div>
      </NavLink>
    );
  }
}
